import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { LOGIN_TYPES } from 'src/app/modules/login/models/login-types';
import { TranslatedSnackBarComponent } from '../components/snack-bar/translated-snack-bar/translated-snack-bar.component';
import { getErrorTranslationLabel } from '../models/error/error-codes';
import { LOCAL_STORAGE_KEYS } from '../models/local-storage-keys';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class HttpResponseHandlerService {
  constructor(
    private _snackBar: MatSnackBar,
    private _router: Router,
    private _authService: AuthService
  ) { }

  public manageError(error: HttpErrorResponse) {

    let errorStatus = error.error.status;
    let errorMsg: string = error.error.message;
    let errorLabel = 'ERRORS.CODES.UNKNOWN_ERROR';
    const isExternalUser = localStorage.getItem(LOCAL_STORAGE_KEYS.LOGIN_TYPE) === LOGIN_TYPES.EXTERNAL
      || !localStorage.getItem(LOCAL_STORAGE_KEYS.LOGIN_TYPE);
    const externalUserDefaultError = 'Server error. Please try again or contact technical support';

    if (errorMsg && errorMsg.startsWith('[')) {
      let errorCode: string = errorMsg.slice(1, 4);
      let translationLabel = getErrorTranslationLabel(errorCode);
      if (translationLabel) {
        errorLabel = 'ERRORS.CODES.' + translationLabel;
      }
      if (isExternalUser) {
        // Default message for external users
        errorLabel = externalUserDefaultError + (errorCode ? (' (error Code: ' + errorCode + ')') : '');
      }
    }

    if (errorMsg && errorMsg.startsWith('Error in row')) {
      errorLabel = errorMsg;
    }

    if (errorMsg && errorMsg.startsWith('Duplicate passengers have been detected')) {
      errorLabel = errorMsg;
    }

    if (errorMsg && errorMsg.startsWith('Por favor rellenar datos de contacto del operador')) {
      errorLabel = errorMsg;
    }

    if (!errorMsg && isExternalUser) {
      // Default message for external users
      errorLabel = externalUserDefaultError;
    }

    /* On unauthorized error redirect to login */
    if (errorStatus == 401) {
      errorLabel = 'ERRORS.CODES.TOKEN_ERROR';
      if (isExternalUser) {
        errorLabel = 'Session has expired'
      }
      this._authService.closeSession();
    } else if (errorStatus === 403) {
      errorLabel = errorMsg;
    }

    this._snackBar.openFromComponent(TranslatedSnackBarComponent, {
      duration: 5000,
      panelClass: ['ep-snackbar-error'],
      data: {
        message: errorLabel
      },
    });

  }

  public manageSuccess() {
    this._snackBar.openFromComponent(TranslatedSnackBarComponent, {
      duration: 1500,
      panelClass: ['ep-snackbar-success', 'ep-snackbar-only-icon'],
      horizontalPosition: 'right',
      verticalPosition: 'top',
      data: {
        icon: 'check_circle',
        // message: 'COMMON.SUCCESSFUL_OPERATION',
      },
    });
  }
}
